module.exports = __webpack_public_path__ + "media/landing_page/instacart-delta-lockup-adaa6f63.svg";